// JWT refresh helper for the multiplexed SSE realtime provider.
// POST /api/auth/refresh is handled by the dev/worker auth proxy and rotates
// HttpOnly cookies when the refresh token is still valid.

export async function refreshJWTAndReconnect(reopen: () => void): Promise<void> {
  try {
    const res = await fetch("/api/auth/refresh", {
      method: "POST",
      credentials: "include",
    });
    if (!res.ok && import.meta.env.DEV) {

      console.warn(`[realtime] auth refresh failed (${res.status}); reconnecting to let SSE auth fallback decide.`);
    }
  } catch (err) {
    if (import.meta.env.DEV) {

      console.warn("[realtime] auth refresh request failed; reconnecting to let SSE auth fallback decide.", err);
    }
  }
  reopen();
}
